<template>
  <div class="ibox">
    <a class="ibox-results-collapse visible-xs" role="button" data-toggle="collapse" href=".ibox-results-filters-collapse-box" aria-expanded="false" aria-controls="ibox-results-filters-collapse-box">
      Show Filters <i class="fa fa-bars"></i>
    </a>
    <div class="ibox-results-filters-collapse-box collapse in">
      <div class="ibox-results-filters">
        <div class="row">
          <div class="col-sm-6 col-lg-4">
            <div class="form-group">
              <label class="control-label">Commodity</label>
              <selectize
                :options="commodityOptionsWithAll"
                name="commodity"
                v-model="commodity">
              </selectize>
            </div>
          </div>
          <div class="col-sm-6 col-lg-4">
            <div class="form-group">
              <label class="control-label">State</label>
              <selectize
                :options="stateOptions"
                name="state"
                v-model="state">
              </selectize>
            </div>
          </div>
          <div class="col-sm-6 col-lg-4">
            <div class="form-group">
              <label class="control-label">Date Range</label>

              <date-range v-model="dateRange" name="date_range"></date-range>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ibox-content">
      <ul class="list-detail list-detail-job-request public-options">
        <job-request-item v-for="job in jobs" :key="job.id" :job="job"></job-request-item>
      </ul>

      <div class="text-center text-muted" v-show="haveNoJobRequests">
        <strong>There are no job requests.</strong>
      </div>
    </div>

    <lazy-loading v-show="haveJobRequests" :reached-bottom="getJobsForNextPage" :filters="filters" ref="lazyLoading">
      <strong slot="finished" class="text-muted">There are no more job requests.</strong>
    </lazy-loading>

    <job-request-modal></job-request-modal>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
  import { states } from 'mixins'
  import { ADD_JOB } from 'vx/mutations'
  import { Selectize, DateRange } from 'components/forms'
  import { LazyLoading } from 'components/misc'
  import { isEqual } from 'lodash'
  import { notify } from 'utils'
  import JobRequestModal from './JobRequestModal'
  import JobRequestItem from './JobRequestItem'
  import $ from 'jquery'

  export default {
    mixins: [states],

    components: {
      JobRequestModal,
      JobRequestItem,
      Selectize,
      DateRange,
      LazyLoading
    },

    data () {
      return {
        commodity: null,
        state: null,
        dateRange: {
          from: null,
          to: null
        }
      }
    },

    watch: {
      /**
       * Watch filters for deep changes, refetch jobs if they change.
       *
       * @type Object
       */
      filters: {
        handler (newFilters, oldFilters) {
          if (isEqual(newFilters, oldFilters)) {
            return
          }

          this.getJobs(this.filters).then(this.resetLazyLoading).catch(this.failedToLoadJobs)
        },
        deep: true
      }
    },

    computed: {
      ...mapGetters('job', { jobs: 'jobsDecorated' }),
      ...mapState('job', ['job']),
      ...mapGetters('commodity', ['commodityOptionsWithAll']),

      filters () {
        return {
          requests: true,
          commodity: this.commodity,
          state: this.state,
          from: this.dateRange.from,
          to: this.dateRange.to
        }
      },

      haveJobRequests () {
        return this.jobs.length > 0
      },

      haveNoJobRequests () {
        return this.jobs.length === 0
      }
    },

    created () {
      if (!this.$user.canManageJobRequests) {
        this.$router.push({ name: 'dashboard' })

        return
      }

      this.getJobRequests()
      this.getCommodities()

      if (this.$route.name === 'jobs.requests.view') {
        this.getJobToView()
      }
    },

    methods: {
      ...mapActions('job', ['getJobs', 'getJobsForNextPage', 'getJob']),
      ...mapMutations('job', [ADD_JOB]),
      ...mapActions('commodity', ['getCommodities']),

      /**
       * Get and show the job request modal for an existing job request.
       *
       * @return Promise
       */
      getJobToView () {
        const addJobToJobs = () => {
          // We need to check that this is actually a job request. If it's not we'll reject here
          // so that we get kicked back to the main job requests route.
          if (this.job.status !== 'pending') {
            return Promise.reject()
          }

          this[ADD_JOB](this.job)
        }

        const showJobRequestModalIfView = () => {
          // Only show the modal if we are viewing the request and not performing an action.
          if (this.$route.name === 'jobs.requests.view' && !this.$route.params.action) {
            setTimeout(() => ($('.modal-job-request').modal('show')), 500)
          }
        }

        const redirectToRequests = () => {
          this.$router.push({ name: 'jobs.requests' })
        }

        return this.getJob(this.$route.params.id).then(addJobToJobs).then(showJobRequestModalIfView).catch(redirectToRequests)
      },

      /**
       * Reset the lazy loading component.
       *
       * @return void
       */
      resetLazyLoading () {
        this.$refs.lazyLoading.$emit('reset')
      },

      /**
       * Failed to load jobs.
       *
       * @return void
       */
      failedToLoadJobs () {
        notify.error('There was a problem loading the jobs.')
      },

      /**
       * Reload the job requests.
       *
       * @return Promise
       */
      getJobRequests () {
        return this.getJobs(this.filters).then(this.resetLazyLoading).catch(this.failedToLoadJobs)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Requests.vue?2485c318